module.exports = __webpack_public_path__ + "static/media/xiaoshouguanli.d23fb452.png";